import React from "react";
import { useTranslation } from "react-i18next";

// Table Header Component
const TableHeader = () => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-6 gap-6 text-white font-bold">
      {[
        t("nav_projects"),
        t("nav_clients"),
        t("date"),
        t("project_brief"),
        t("period"),
      ].map((heading, index) => (
        <div
          key={heading}
          className={`min-w-[200px] xl:min-w-0 ${
            index === 0 ? "col-span-2" : "col-span-1"
          }`}
        >
          <p className="text-secondary border-b-[3px] border-[#8b8b8b] font-medium text-2xl">
            {heading}
          </p>
        </div>
      ))}
    </div>
  );
};

const ProjectLanding = ({ data }) => {
  return (
    <div className="px-4 bg-black lg:px-20 pb-32 bg-black overflow-x-auto border-b">
      <div className="min-w-[1200px] xl:min-w-0">
        <TableHeader />

        {data?.length ? (
          data.map(
            (
              {
                project_name,
                project_brief,
                project_period,
                project_client,
                year,
                id,
              },
              index
            ) => (
              <div
                key={id || index} // Use `id` if available, fallback to `index`
                className="grid grid-cols-6 gap-6 text-gray-300 mb-4 mt-2"
              >
                <div className="col-span-2 min-w-[200px] xl:min-w-0">
                  {project_name}
                </div>
                <div className="min-w-[200px] max-w-[200px] xl:min-w-0 xl:max-w-none">
                  {project_client}
                </div>
                <div className="min-w-[200px] max-w-[200px] xl:min-w-0 xl:max-w-none">
                  {year}
                </div>
                <div className="min-w-[200px] max-w-[200px] xl:min-w-0 xl:max-w-none">
                  {project_brief}
                </div>
                <div className="min-w-[200px] max-w-[200px] xl:min-w-0 xl:max-w-none">
                  {project_period}
                </div>
              </div>
            )
          )
        ) : (
          <div className="text-gray-400 mt-4 text-center">
            <p>No projects available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectLanding;
